import {Spinner} from '@volkswagen-onehub/components-core'

import React from 'react'
import styled from 'styled-components'

const LoadingContainer = styled.div`
    background: ${(props) => props.theme.colors.background.primary};
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    left: 0;
    top: 0;
    justify-content: center;
`

export function Loading(): React.JSX.Element {
    return (
        <LoadingContainer>
            <Spinner variant="x-large" />
        </LoadingContainer>
    )
}
